export var UpdateAccountTypeIA = function UpdateAccountTypeIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return UPDATE_ACCOUNT_TYPE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [PLEASE_SEND_US_THE_FOLLOWING_INFO(strictLocalize), FIRST_STEP_TO_UPDATE_ACCOUNT_TYPE(strictLocalize), SECOND_STEP_TO_UPDATE_ACCOUNT_TYPE(strictLocalize), ONCE_WE_RECEIVE_THIS_INFO(strictLocalize)];
    }
  };
};
var UPDATE_ACCOUNT_TYPE = function UPDATE_ACCOUNT_TYPE(strictLocalize) {
  return strictLocalize({
    id: "QzoC6y",
    defaultMessage: [{
      "type": 0,
      "value": "Accounttype bijwerken naar ‘Fysieke winkel’"
    }]
  });
};
var PLEASE_SEND_US_THE_FOLLOWING_INFO = function PLEASE_SEND_US_THE_FOLLOWING_INFO(strictLocalize) {
  return strictLocalize({
    id: "oR9T2X",
    defaultMessage: [{
      "type": 0,
      "value": "Stuur ons om dit proces te beginnen de volgende gegevens via de contactoptie(s) in de sectie ‘Contact opnemen’:"
    }]
  });
};
var FIRST_STEP_TO_UPDATE_ACCOUNT_TYPE = function FIRST_STEP_TO_UPDATE_ACCOUNT_TYPE(strictLocalize) {
  return strictLocalize({
    id: "rAF0hs",
    defaultMessage: [{
      "type": 0,
      "value": "1. Het fysieke adres van je fysieke winkel"
    }]
  });
};
var SECOND_STEP_TO_UPDATE_ACCOUNT_TYPE = function SECOND_STEP_TO_UPDATE_ACCOUNT_TYPE(strictLocalize) {
  return strictLocalize({
    id: "MvxnaR",
    defaultMessage: [{
      "type": 0,
      "value": "2. Foto's van het interieur en exterieur van je winkel met je winkelbord zichtbaar op de foto's van het exterieur"
    }]
  });
};
var ONCE_WE_RECEIVE_THIS_INFO = function ONCE_WE_RECEIVE_THIS_INFO(strictLocalize) {
  return strictLocalize({
    id: "ElLq0T",
    defaultMessage: [{
      "type": 0,
      "value": "Zodra we deze informatie hebben ontvangen, werkt ons supportteam je accounttype bij of bespreken we graag eventuele vragen die we voor je hebben."
    }]
  });
};